define('ItemRelations.Related.Collection.Fix', [
    'ItemRelations.Related.Collection',
    'underscore'
], function ItemRelationsRelatedCollectionFix(
        ItemRelationsRelatedCollection,
    _
) {
    'use strict';

    _.extend(ItemRelationsRelatedCollection.prototype, {
        fetchItems: _.wrap(ItemRelationsRelatedCollection.prototype.fetchItems, function fetchItemExtend(fn) {
            var results = fn.apply(this, _.toArray(arguments).slice(1));
            results.fail(function failFetch(jqXhr) {
                jqXhr.preventDefault = true;
            });
            return results;
        })
    });
});

